import { render, staticRenderFns } from "./ReplyComment.vue?vue&type=template&id=3246b9c5&scoped=true"
import script from "./ReplyComment.vue?vue&type=script&lang=js"
export * from "./ReplyComment.vue?vue&type=script&lang=js"
import style0 from "./ReplyComment.vue?vue&type=style&index=0&id=3246b9c5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246b9c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3246b9c5')) {
      api.createRecord('3246b9c5', component.options)
    } else {
      api.reload('3246b9c5', component.options)
    }
    module.hot.accept("./ReplyComment.vue?vue&type=template&id=3246b9c5&scoped=true", function () {
      api.rerender('3246b9c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReplyComment.vue"
export default component.exports